import React, { useEffect, useRef, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import { toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import swal from "sweetalert2";
import * as Yup from "yup";
import { useFormik } from "formik";
import ClipLoader from "react-spinners/ClipLoader";
import ThumbnailPreview from "./ThumbnailPreview";

function NewsDetails() {
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const [heading, setHeading] = useState("");
  const [descriptionData, setDescriptionData] = useState("");
  const [newContent, setNewContent] = useState({});
  const [image, setImage] = useState();
  const editor = useRef(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialValue, setInitialValues] = useState({
    heading: "",
    content: "",
    newsImage: "",
    description: "",
  });

  const validationSchema = Yup.object({
    heading: Yup.string()
      .max(500, "Heading must be at most 500 characters")
      .trim()
      .required("Heading is a required field"),
    content: Yup.string().trim().required("Content is a required"),
    description: Yup.string()
      .max(2000, "Description must be at most 2,000 characters")
      .trim()
      .required("Description is a required"),
    newsImage: Yup.mixed()
      .nullable()
      .test("fileOrUrl", "Must be a valid URL or a file", function (value) {
        if (!value) return true; // Allow null or undefined values

        const isUrl = typeof value === "string" && /^https?:\/\//.test(value);
        const isFile = value instanceof File; // If it's a File object

        // Alternatively, you can check for specific file types if needed:
        const isFileExtension =
          typeof value === "string" && /\.(jpg|jpeg|png)$/i.test(value);

        return isUrl || isFile || isFileExtension;
      }),
    // .test(
    //   "imageDimensions",
    //   "Image dimensions must be at max 900px width and height minimum 400px",

    //   // "Image dimensions must be at max 800px width and height between 500px and 550px",
    //   async (value) => {
    //     if (!value) return true; // no file, skip
    //     if (!(value instanceof File)) return true; // skip if it's a URL string

    //     const file = value;

    //     // Create a promise to get the image dimensions
    //     const imageDimensions = new Promise((resolve, reject) => {
    //       const reader = new FileReader();
    //       reader.onload = (event) => {
    //         const img = new Image();
    //         img.onload = () => {
    //           resolve({ width: img.width, height: img.height });
    //         };
    //         img.onerror = reject;
    //         img.src = event.target.result;
    //       };
    //       reader.onerror = reject;
    //       reader.readAsDataURL(file);
    //     });

    //     const { width, height } = await imageDimensions;
    //     // return width <= 900 && height >= 500 && height <= 550;
    //     return width <= 900 && height >= 400;
    //   }
    // ),
    // .test(
    //   "fileType",
    //   "Only image files are allowed",
    //   (value) =>
    //     value &&
    //     ["image/jpeg", "image/svg", "image/jpg", "image/png"].includes(
    //       value.type
    //     )
    // ),
  });

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      console.log("valllllllll", values);
      //    setDisabledSubmit(true);
      setLoading(true);
      try {
        let formData = new FormData();
        formData.append("newsImage", values.newsImage);
        formData.append("heading", values.heading);
        formData.append("description", values.description);
        formData.append("content", newContent);
        // console.log("Formdata", formData);
        let res = await axios.patch(`admin-website/updateNews/${id}`, formData);
        // console.log("res ==> ", res);
        // setRenderPage(Math.random());
        // setDisabledSubmit(false);
        toast(res.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "success",
        });

        navigate(-1);

        // navigate("/category", { state: { message: res.data.message } });
      } catch (errors) {
        if (errors.response.data.error) {
          toast(errors.response.data.error.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "error",
          });
        }
        // setDisabledSubmit(false);
      }
      setLoading(false);
    },
  });

  const handleNewsImage = (e) => {
    const file = e.target.files[0];
    setImage(file);
    formik.setFieldValue("newsImage", file);
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(`/website/get-news/${id}`)
      .then((res) => res.data.data)
      .then((data) => {
        // console.log(data);
        setInitialValues({
          heading: data.heading,
          content: data.content,
          description: data.description,
          newsImage: data.newsImage,
        });
        setImage(data.newsImage);
        setHeading(data.heading);
        setContent(data.content);
        setTitle(data.topic);
        setDescriptionData(data.description);
        setLoading(false);
      });
  }, []);

  const newContentData = {
    pageContent: newContent,
  };

  const handleCloseButton = () => {
    navigate(-1);
  };

  return (
    <>
      {/* // <Container> */}
      <div
        className="editing-box p-3"
        style={{ backgroundColor: "white", height: "100vh" }}
      >
        <div
          className="box"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <h3 className="header">Edit Blogs</h3>
          <Container>
            <i
              className="fa fa-close fonts py-2"
              onClick={handleCloseButton}
              style={{ fontSize: "large" }}
            ></i>
          </Container>
        </div>
        <div
          className="main mx-auto p-3"
          style={{
            border: "2px solid #bebdbf",
            width: "80%",
          }}
        >
          <form
            onSubmit={(e) => {
              e.preventDefault();
              console.log("FORM SUBMITTED");
              formik.handleSubmit(e);
            }}
            // onSubmit={formik.handleSubmit}
          >
            <div
              className="title p-2"
              style={{
                // border: "2px solid red",
                backgroundColor: "#d5cce0",
                color: "grey",
              }}
            >
              {title}
            </div>
            <div className="image-container input-group input-group-outline mb-3">
              <label className="fs-5">
                Blog Related Image
                {/* (max 900px width and height minimum 400px ) */}
              </label>
              <input
                style={{
                  width: "100%",
                  padding: "10px",
                  fontSize: "16px",
                  borderRadius: "5px",
                  outline: "none",
                  border: "1px solid #ccc",
                  height: "50px",
                }}
                type="file"
                id="newsImage"
                name="newsImage"
                // className="form-control"
                placeholder="News Image"
                // onChange={(event) => {
                //   formik.setFieldValue(
                //     "sportLogo",
                //     // setformImage(event.target.files[0]),
                //     event.target.files[0]
                //   );
                // }}
                onChange={handleNewsImage}
              />
            </div>
            <ThumbnailPreview
              file={image instanceof File ? image : null}
              src={typeof image === "string" ? image : formik.values.newsImage}
              alt="Current blog thumbnail preview"
            />
            {formik.errors.newsImage ? (
              <div className="text-danger">{formik.errors.newsImage}</div>
            ) : null}

            <div className="input-group input-group-outline mb-3">
              <input
                type="text"
                id="heading"
                name="heading"
                className="form-control"
                placeholder="News Heading"
                value={formik.values.heading || ""}
                onChange={formik.handleChange}
              />
            </div>
            {formik.errors.heading ? (
              <div className="text-danger">{formik.errors.heading}</div>
            ) : null}

            <div className="input-group input-group-outline mb-3">
              <input
                type="text"
                id="description"
                name="description"
                className="form-control"
                placeholder="News Desription"
                value={formik.values.description || ""}
                onChange={formik.handleChange}
              />
            </div>
            {formik.errors.description ? (
              <div className="text-danger">{formik.errors.description}</div>
            ) : null}

            <CKEditor
              editor={ClassicEditor}
              data={content}
              // onReady={editor => {
              //     console.log('Editor is ready to use!', editor);
              // }}
              config={{
                toolbar: [
                  "undo",
                  "redo",
                  "|",
                  "heading",
                  "|",
                  "bold",
                  "italic",
                  "|",
                  "link",
                  "bulletedList",
                  "numberedList",
                ],
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                setNewContent(data);
              }}
              // onChange = {formik.handleChange}
              // onBlur={(event, editor) => {
              //     console.log('Blur.', editor);
              // }}
              // onFocus={(event, editor) => {
              //     console.log('Focus.', editor); `
              // }}
            />
            <button
              type="submit"
              className="Submit my-3 btn-lg"
              style={{
                width: "100%",
                border: "1px solid grey",
                height: "50px",
                borderRadius: "2px",
              }}
              disabled={loading}
            >
              {loading ? <ClipLoader /> : "Submit"}
            </button>
          </form>
        </div>
      </div>
      {/* </Container> */}
    </>
  );
}

export default NewsDetails;

const Container = styled.div`
  i {
    /* text-align: end; */
    position: absolute;
    top: 20px;
    right: 30px;
    font-size: 1.6rem;
    cursor: pointer;

    :hover {
      color: red;
      font-size: 1.8rem;
      cursor: pointer;
    }
  }
`;
